import { AdBlockQualifier } from "./AdBlockQualifier";
import { DeviceTypeQualifier } from "./DeviceTypeQualifier";
import { BrowserDetectionQualifier } from "./BrowserDetectionQualifier";
import { IncognitoModeQualifier } from "./IncognitoModeQualifier";
import { UrlParamQualifier } from "./UrlParamQualifier";
import { UserStateQualifier } from "./UserStateQualifier";
import { DayTimeQualifier } from "./DayTimeQualifier";
import { MatherSegmentsQualifier } from "./MatherSegmentsQualifier";
import { BlockedThirdPartyCookiesQualifier } from "./BlockedThirdPartyCookiesQualifier";
import { BlockedCookiesOrLsQualifier } from "./BlockedCookiesOrLsQualifier";
import { ArticleAgeQualifier } from "./ArticleAgeQualifier";
import { RegistrationWallsQualifier } from "./RegistrationWallsQualifier";
import { ComingFromSocialQualifier } from "./ComingFromSocialQualifier";
import { CountryQualifier } from "./CountryQualifier";
import { UrlMaskQualifier } from "./UrlMaskQualifier";
import { EzPayQualifier } from "./EzPayQualifier";
import { GeoQualifier } from "./GeoQualifier";
import { MetaKeywordQualifier } from "./MetaKeywordQualifier";
import { SubscriptionCreationDateQualifier } from "./SubscriptionCreationDateQualifier";
import { SubscriptionExpirationQualifier } from "./SubscriptionExpirationQualifier";
import { IsEuMemberQualifier } from "./IsEuMemberQualifier";
import { MeterViewQualifier } from "./MeterViewQualifier";
import { ConversationViewQualifier } from "./ConversationViewQualifier";
import { JavascriptQualifier } from "./JavascriptQualifier";
import { PromiseQualifier } from "./PromiseQualifier";
import { NewsletterReaderQualifier } from "./NewsletterReaderQualifier";
import { NewsletterSessionQualifier } from "./NewsletterSessionQualifier";
import { NewVisitorQualifier } from "./NewVisitorQualifier";
import { VisitInLastDaysQualifier } from "./VisitInLastDaysQualifier";
import { logService } from "@Engage.Core";
import { StartEndDatesQualifier } from "./StartEndDatesQualifier";
function getCookieValue(name) {
    try {
        const cookies = document.cookie.split("; ");
        for (const cookie of cookies) {
            const [key, value] = cookie.split("=");
            if (key === name) {
                const decoded = decodeURIComponent(value);
                return encodeURIComponent(encodeURIComponent(decoded));
            }
        }
        return null;
    }
    catch (_a) {
        return null;
    }
}
const qualifierMap = {
    AdBlock: AdBlockQualifier,
    DeviceType: DeviceTypeQualifier,
    BrowserDetection: BrowserDetectionQualifier,
    IncognitoMode: IncognitoModeQualifier,
    UrlParam: UrlParamQualifier,
    UserState: UserStateQualifier,
    DayTime: DayTimeQualifier,
    MatherSegments: MatherSegmentsQualifier,
    BlockedThirdPartyCookies: BlockedThirdPartyCookiesQualifier,
    BlockedCookiesOrLs: BlockedCookiesOrLsQualifier,
    ArticleAge: ArticleAgeQualifier,
    RegistrationWalls: RegistrationWallsQualifier,
    ComingFromSocial: ComingFromSocialQualifier,
    Country: CountryQualifier,
    UrlMask: UrlMaskQualifier,
    EzPay: EzPayQualifier,
    Geo: GeoQualifier,
    MetaKeyword: MetaKeywordQualifier,
    SubscriptionCreationDate: SubscriptionCreationDateQualifier,
    SubscriptionExpiration: SubscriptionExpirationQualifier,
    IsEuMember: IsEuMemberQualifier,
    MeterView: MeterViewQualifier,
    ConversationView: ConversationViewQualifier,
    Javascript: JavascriptQualifier,
    Promise: PromiseQualifier,
    NewsletterReader: NewsletterReaderQualifier,
    NewsletterSession: NewsletterSessionQualifier,
    IsNewVisitor: NewVisitorQualifier,
    VisitsLastDays: VisitInLastDaysQualifier,
    StartEndDates: StartEndDatesQualifier
};
export class QualifierFactory {
    static build(qualifierList) {
        return Object.keys(qualifierList)
            .map((key) => {
            const QualifierClass = qualifierMap[key];
            if (!QualifierClass)
                return null;
            return new QualifierClass(qualifierList[key]);
        })
            .filter(Boolean);
    }
    static async processAllAsync(qualifierList) {
        var _a;
        const qualifiers = this.build(qualifierList);
        const masterId = (_a = getCookieValue("auth0_sub")) !== null && _a !== void 0 ? _a : "";
        logService.log('[QualifierFactory] Processing qualifiers', `count=${qualifiers.length}`);
        // run all qualifier process() calls in parallel — allSettled so one failure doesn't kill the rest
        const results = await Promise.allSettled(qualifiers.map(q => Promise.resolve(q.process(qualifierList[q.key]))));
        const request = [];
        let userState = "";
        qualifiers.forEach((qualifier, i) => {
            const result = results[i];
            if (result.status === 'rejected') {
                logService.warn(`[QualifierFactory] qualifier "${qualifier.key}" failed`, result.reason);
                return;
            }
            const apiValue = qualifierList[qualifier.key];
            const value = result.value;
            if (Array.isArray(value)) {
                value.forEach((v) => {
                    var _a, _b;
                    return request.push({
                        type: qualifier.key,
                        key: (_a = v.key) !== null && _a !== void 0 ? _a : "",
                        value: (_b = v.value) !== null && _b !== void 0 ? _b : ""
                    });
                });
            }
            else {
                request.push({
                    type: qualifier.key,
                    key: typeof apiValue === "string" ? apiValue : "",
                    value
                });
            }
            if (qualifier.key === "UserState") {
                userState = value;
            }
        });
        logService.log('[QualifierFactory] Payload built', `requestItems=${request.length}`, `userState=${userState}`);
        return { request, userState, masterId };
    }
}
